<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.marka_bildirimi"  url="BrandNotifications" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">


<div class="mt-4">

<ClickEditInputText  title="İsim" :value="item.name" valkey="name" @dataChanged="dataChanged"></ClickEditInputText>
<ClickEditSwitch  title="Dashboardda Göster" :value="item.show_on_dashboard" valkey="show_on_dashboard" @dataChanged="dataChanged" />
<ClickEditCalendar  title="Geçerlilik Tarihi" :value="item.valid_until" valkey="valid_until" @dataChanged="dataChanged" v-if="item.show_on_dashboard"/>


<div  v-for="translation in item.translations" >
<h4 class="text-primary">{{translation.language.name}} için çeviriler</h4>
<ClickEditInputText   :title="translation.language.name+ ' İsmi'" :value="translation.translation" valkey="translation" @dataChanged="translationChanged($event,translation.id)" ></ClickEditInputText> 

<ClickEditInputRichTextArea  :title="translation.language.name+ ' Özet'" :value="translation.excerpt" valkey="excerpt" @dataChanged="translationChanged($event,translation.id)" />

<ClickEditInputRichTextArea  :title="translation.language.name+ ' Metin'" :value="translation.message" valkey="message" @dataChanged="translationChanged($event,translation.id)" />



</div>

<div class="grid">
<div class="col-12 md:col-6">
<h4 class="text-primary">Bildirim Gönderilen Tedarikçiler</h4>
</div>




<div class="col-12 md:col-6 mt-3">

<div class="grid">
<div class="col-9">
<AutoComplete 
v-model="selectedSupplier" 
optionLabel="name" 
:suggestions="suggestedSuppliers" 
@complete="searchSupplier" 
@item-select="itemSelected"
class="w-full p-inputtext-sm "
placeholder="Tedarikçi isim ya da kodu ile ara"
>
<template #item="slotProps">
   {{slotProps.item.name}} - {{slotProps.item.suppliercode}} 
</template>
</AutoComplete>
</div>

<div class="col-3">
<Button 
:label="$store.state.languages.lang_phrases.toplu_yukle" 
class="p-button-primary p-button-outlined  p-button-sm " 
@click="openUploadModal" 
></Button>
</div>
</div>

  
</div>

</div>








<ScrollPanel style="width: 100%; height: 400px">
<DataTable 
:value="selectedSuppliers" 
:lazy="true" 
class="p-datatable-suppliers" 
dataKey="id" 
:rowHover="true" 
filterDisplay="menu"  
responsiveLayout="scroll"
>

<Column field="name" :header="$store.state.languages.lang_phrases.isim"  style="min-width: 15rem;max-width:20rem">
  <template #body="{data}">
      <router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'Supplier' , params: {id:data.id}}">{{data.name}}</router-link>
  </template>
 
</Column>

<Column field="suppliercode" :header="$store.state.languages.lang_phrases.tedarikci_kodu"  style="min-width: 15rem;max-width:20rem">
  <template #body="{data}">
      <p>{{data.suppliercode}}</p>
  </template> 
</Column>

</DataTable>
</ScrollPanel>



<div class="flex justify-content-end flex-wrap mt-3">
 <Button :label="$store.state.languages.lang_phrases.kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>


</div>


</template>
<NotificationUploader @listUpdated="listUpdated" ref="uploader"/>
</div>
</template>

<script>
import NotificationUploader from "./NotificationUploader"
export default {

  name: 'BrandNotification',

  data () {
    return {
    	loading:true, 
      suppliers:[],
    	item:null,
      selectedSupplier:null,
      selectedSuppliers:[],
      suggestedSuppliers:[],
    }
  },
  components:{NotificationUploader},
  mounted()
  {
  	this.getData()
  },
  methods:{ 
    openUploadModal()
    {
      this.$store.dispatch('brands/setNotificationUploader',true) 
    },
    itemSelected(data)
    {      
      let item = this.sanitizeArray(this.selectedSupplier)
      if(item.projectsuppliers)
      {
        delete item.projectsuppliers
      }
      
      let ind = this.selectedSuppliers.findIndex(element=>element.id == item.id)
      if(ind == -1)
      {
        this.selectedSuppliers.push(item)
        this.submitAdditionalSuppliers([item])
      }
      this.selectedSupplier = null
      
    },
    listUpdated(data)
    {
      console.log("listUpdated")
      console.log(data)
      for(let item of data)
      {
        let ind = this.selectedSuppliers.findIndex(element=>element.id == item.id)
        if(ind == -1)
        {
          this.selectedSuppliers.push(item)
        }
      }

      setTimeout(()=>{
        this.$refs.uploader.close()
      },50)
      this.submitAdditionalSuppliers(data)
      
    },
    submitAdditionalSuppliers(arr)
    {
      arr = arr.map(item=>item.id)
      let formdata = new FormData()
      formdata.append("suppliers",JSON.stringify(arr))
      formdata.append("brand_id",this.$route.params.id)
      formdata.append("notification_id",this.$route.params.notification_id)
      this.generalSubmission(formdata,"brand/add_more_notifications",this.aftersubmitAdditionalSuppliers)
    },
    aftersubmitAdditionalSuppliers(response)
    {

    },
    async searchSupplier(event)
    {
      let searchterm = await event.query.toUpperCase();
      let data = await this.generalApiGetWithoutLoader("brand/suppliers/"+this.$route.params.id+"/0/10?search="+searchterm)
      console.log(data)
      this.suggestedSuppliers = data.data
    },
  	async getData()
  	{
      console.log("getdata")
  		this.loading = await true
      //this.suppliers = await this.generalApiGetWithoutLoader("brand/all_suppliers/"+this.$route.params.id)
  		this.item = await this.generalApiGetWithoutLoader("brand/brand_notification/"+this.$route.params.notification_id)
      //let item_suppliers = JSON.parse(this.item.selected_suppliers)
      this.selectedSuppliers = await this.generalApiGetWithoutLoader("brand/get_suppliers_for_notifications_with_id?suppliers="+this.item.selected_suppliers)
      console.log("selectedSuppliers")
      console.log(this.selectedSuppliers)
  		this.loading = await false

  	},
  	dataChanged(data)
  	{
      let formdata = new FormData()
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"brand/update_brand_notification/"+this.item.id,this.afterdataChanged)
  	},
    afterdataChanged(response)
    {
      console.log("data changed");
      console.log(response.data);  
      this.item = response.data   
    },
    translationChanged(data,id)
    {
      let formdata = new FormData()
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"brand/update_brand_notification_translation/"+id,this.afterdataChanged)
    }
  },
}
</script>

<style lang="css" scoped>
</style>